import { SEO_BASE_URL } from './seoDiscovery.js';

export const ORGANIZATION_SCHEMA_ID = `${SEO_BASE_URL}/#organization`;
export const WEBSITE_SCHEMA_ID = `${SEO_BASE_URL}/#website`;
export const SOFTWARE_APPLICATION_SCHEMA_ID = `${SEO_BASE_URL}/#software-application`;
// The Stocktag Editorial Team, defined on /editorial-policy. Blog, comparison,
// alternatives, help and trust pages all refer to it by this one id.
export const EDITORIAL_TEAM_SCHEMA_ID = `${SEO_BASE_URL}/editorial-policy#editorial-team`;

export const buildWebPageSchemaId = (canonicalUrl = SEO_BASE_URL) => (
  `${String(canonicalUrl || SEO_BASE_URL).replace(/#.*$/, '')}#webpage`
);

export const organizationSchemaRef = () => ({ '@id': ORGANIZATION_SCHEMA_ID });
export const websiteSchemaRef = () => ({ '@id': WEBSITE_SCHEMA_ID });
export const webPageSchemaRef = (canonicalUrl) => ({ '@id': buildWebPageSchemaId(canonicalUrl) });
